export const uploadingFile = ({
  indexedAsyncFileUploads
}) => {
  return indexedAsyncFileUploads && indexedAsyncFileUploads.size ? {
    disabled: true,
    sendDisabledReason: 'UPLOADING_FILE'
  } : null;
};